/**
 * グローバルダイアログストア
 */
import { defineStore } from "pinia";
import { ref } from "vue";

export const useDialogStore = defineStore("dialog", () => {
  const isOpen = ref(false);
  const title = ref("");
  const message = ref("");
  const type = ref<"alert" | "confirm">("alert");

  // Promise のresolveを保持
  let resolvePromise: ((value: boolean) => void) | null = null;

  /**
   * アラートダイアログを表示
   */
  function showAlert(msg: string, titleText = "通知"): Promise<void> {
    title.value = titleText;
    message.value = msg;
    type.value = "alert";
    isOpen.value = true;

    return new Promise<void>((resolve) => {
      resolvePromise = () => {
        resolve();
      };
    });
  }

  /**
   * 確認ダイアログを表示
   */
  function showConfirm(msg: string, titleText = "確認"): Promise<boolean> {
    title.value = titleText;
    message.value = msg;
    type.value = "confirm";
    isOpen.value = true;

    return new Promise<boolean>((resolve) => {
      resolvePromise = resolve;
    });
  }

  /**
   * 確認ボタンがクリックされた
   */
  function confirm() {
    isOpen.value = false;
    if (resolvePromise) {
      resolvePromise(true);
      resolvePromise = null;
    }
  }

  /**
   * キャンセルボタンがクリックされた
   */
  function cancel() {
    isOpen.value = false;
    if (resolvePromise) {
      resolvePromise(false);
      resolvePromise = null;
    }
  }

  return {
    isOpen,
    title,
    message,
    type,
    showAlert,
    showConfirm,
    confirm,
    cancel,
  };
});
